<template>
<div class="chapter">
<div class="inner_page">
<div class="bodyMatter">
<div class="partHead" id="ph01">
<h2 class="partTitle"><span class="xrefInternal"><a href="#/contents#ph_01"><span class="bold">PROLOGUE</span></a></span></h2>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ph01.vue?71bcf364